export default __webpack_public_path__ + "static/media/boy.61329d55.jpg";